import * as React from 'react'

const warnNoProvider = () => {
  // tslint:disable-next-line
  console.warn('[createUseContext] Missing Provider')
}
const canUseProxy =
  process.env.NODE_ENV === 'development' && typeof Proxy !== 'undefined'

const defaultValue = canUseProxy
  ? new Proxy({}, { get: warnNoProvider, apply: warnNoProvider })
  : {}

export default <P, V>(useValue: (props: P) => V) => {
  const Context = React.createContext(defaultValue as V)

  const Provider = (props: { children?: React.ReactNode } & P) => {
    const value = useValue(props)

    return <Context.Provider value={value}>{props.children}</Context.Provider>
  }

  const useContext = () => React.useContext(Context)

  useContext.Context = Context

  useContext.Provider = Provider

  return useContext
}
